import type { LeadSourceTab, LeadStageTab } from '@borradh-workspace/labels';

/**
 * The Customers view bar, Leads first (the page opens on it) and All last. A
 * person is a lead until their first booking or paid sale and a customer
 * (`clients`) from then on. Lost has no tab of its own: those people are under
 * All. Each `value` is passed as the `stageGroup` query param — `all` applies
 * no filter server-side (see `leadStageGroups`).
 */
export const STAGE_GROUP_TABS: readonly {
  value: LeadStageTab;
  label: string;
}[] = [
  { value: 'leads', label: 'Leads' },
  { value: 'clients', label: 'Customers' },
  { value: 'all', label: 'All' },
];

/**
 * Lead sources the Leads tab's source strip never shows. Referral and
 * front-desk entries are not channels the clinic works as a source; those
 * leads stay under "All leads".
 */
export const HIDDEN_SOURCE_TABS: ReadonlySet<LeadSourceTab> = new Set([
  'referral',
  'team',
]);

/**
 * Shown even at zero: Lead forms is the source a clinic most expects to see,
 * and an empty tab says "no lead-form leads yet" where a missing one reads as
 * "this page does not know about lead forms".
 */
export const ALWAYS_SHOWN_SOURCE_TABS: ReadonlySet<LeadSourceTab> = new Set([
  'meta_ads',
]);

/** A Leads source tab, or `all` — the "All leads" tab, last in the strip. */
export type LeadSourceView = LeadSourceTab | 'all';

/** The source tab Leads opens on. */
export const DEFAULT_SOURCE_VIEW: LeadSourceView = 'meta_ads';
